import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import mixins from './mixins'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);
import 'typeface-fira-sans';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

Vue.use(require('vue-moment'));

import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  timeout: 4000,
  theme: 'bootstrap-v4',
  progressBar: true,
  layout: 'topRight'
});

Vue.config.productionTip = false

import '@/lib/icons'

import Infopanel from './components/helpers/Infopanel.vue'
import Speaker from './components/helpers/Speaker.vue'
import ProcessingButton from "./components/helpers/ProcessingButton";
import Loader from './components/helpers/Loader';

Vue.component('Infopanel', Infopanel);
Vue.component('Speaker', Speaker);
Vue.component('Loader', Loader);
Vue.component('ProcessingButton', ProcessingButton);

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app');
